import { useEffect, useMemo, useState } from "react";
import { CommentForm, type CommentDraft } from "./CommentForm";
import { CommentList, type StoredComment } from "./CommentList";

type CommentsProps = {
  postSlug: string;
};

export function Comments({ postSlug }: CommentsProps) {
  const storageKey = useMemo(() => `yawiki:comments:${postSlug}`, [postSlug]);
  const [comments, setComments] = useState<StoredComment[]>([]);

  useEffect(() => {
    const stored = window.localStorage.getItem(storageKey);
    setComments(stored ? (JSON.parse(stored) as StoredComment[]) : []);
  }, [storageKey]);

  function handleSubmit(comment: CommentDraft) {
    const nextComments = [
      ...comments,
      {
        id: window.crypto.randomUUID(),
        name: comment.name,
        body: comment.body,
        createdAt: new Date().toISOString()
      }
    ];

    setComments(nextComments);
    window.localStorage.setItem(storageKey, JSON.stringify(nextComments));
  }

  return (
    <section className="comments" aria-labelledby="comments-title">
      <h2 id="comments-title">Comments</h2>
      <CommentList comments={comments} />
      <CommentForm onSubmit={handleSubmit} />
    </section>
  );
}
